import {getDateForDripSequenceHeader} from 'shells/drip-sequence-list-item/get-date-for-drip-sequence-header';
import {getDripEditionStatusInfo} from 'shells/edition/get-edition-status-info';

import type {
    DripSequenceFragment as DripSequence,
    SmsDripSequenceFragment as SmsDripSequence,
} from 'nutshell-graphql-types';

import {DRIP_RECIPIENT_STATUS_FILTERS} from './consts';

// Removes drip specific filters from showing / considered 'selected'
export const dripSequenceFieldFilterFunction = (fieldName: string) =>
    ![
        'sentDripSequences',
        'receivedDripSequences',
        'viewedDripSequences',
        'clickedDripSequences',
        'period',
        ...DRIP_RECIPIENT_STATUS_FILTERS.map((status) => status.id),
    ].includes(fieldName);

// Status bar for a drip sequence. Displays the status badge, the date
// the last status change occured (paused on September 12th, etc), and
// then metadata related to that status change.
export function getDripSequenceStatusBarInfo(dripSequence: DripSequence | SmsDripSequence) {
    return {
        status: getDripEditionStatusInfo(dripSequence.status),
        primaryText: getDateForDripSequenceHeader(dripSequence),
        secondaryText: getDripSequenceSecondaryText(dripSequence),
    };
}

function getDripSequenceSecondaryText(dripSequence: DripSequence | SmsDripSequence) {
    const sentCount = dripSequence.engagementStats.dripProgressionTotalRecipients || 0;

    const status = dripSequence.status;
    const sentToMessage = `Sent to ${sentCount.toLocaleString()} ${
        sentCount !== 1 ? 'recipients' : 'recipient'
    }`;

    if (status === 'ACTIVE' || status === 'RETIRED' || status === 'CANCELLED') {
        return sentToMessage;
    } else if (status === 'PAUSED') {
        return `${sentToMessage} • Currently paused and not adding any new recipients`;
    } else if (status === 'PROBLEM') {
        return `${sentToMessage} • Currently paused due to a problem sending`;
    }

    return 'This drip sequence hasn’t been activated yet';
}
